import { collection, doc, getDocs, setDoc } from 'firebase/firestore';
import { Contractor, ContractorStatus } from '../../entities';
import { db, Collections } from '../../utils/firebase.config';
import { converterOf } from '../../utils/firebase.utils';

export const useContractors = () => {
  const contractorsCollection = collection(db, Collections.Contractors).withConverter(converterOf(Contractor));

  const fetchAll = async (): Promise<Contractor[]> => {
    const contractorsDocs = await getDocs(contractorsCollection);

    return contractorsDocs.docs.map((contractorDoc) => contractorDoc.data());
  };

  const update = async (input: Partial<Contractor> & { id: string }): Promise<void> => {
    const contractorDoc = doc(contractorsCollection, input.id);

    return setDoc(contractorDoc, input);
  };

  const create = async (input: Omit<Contractor, 'id' | 'status'>): Promise<Contractor> => {
    const contractorDoc = doc(contractorsCollection);

    const data = new Contractor({ ...input, id: contractorDoc.id, status: ContractorStatus.Pending });

    await setDoc(contractorDoc, data);

    return data;
  };

  return { fetchAll, update, create };
};

export default useContractors;
